import { render, staticRenderFns } from "./IOTNotifyUsers.vue?vue&type=template&id=8ddfdad0"
import script from "./IOTNotifyUsers.vue?vue&type=script&lang=js"
export * from "./IOTNotifyUsers.vue?vue&type=script&lang=js"
import style0 from "./IOTNotifyUsers.vue?vue&type=style&index=0&id=8ddfdad0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports